export const AUTH_TYPE = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  QUICK_SIGNUP: 'quick_signup',
  MAGIC_LINK: 'MAGIC_LINK',
  GOOGLE: 'GOOGLE',
  FACEBOOK: 'FACEBOOK',
  MODAL_SIGNUP: 'modal_signup',
  OTP: 'OTP',
};
